import api from './api';

// Service pour les SAV (Service Après-Vente)
export const savsService = {
  // Récupérer tous les SAV
  getAllSavs: (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (filters.status) params.append('status', filters.status);
    if (filters.orderId) params.append('orderId', filters.orderId);
    if (filters.search) params.append('search', filters.search);
    return api.get(`/api/savs?${params.toString()}`);
  },

  // Récupérer les statistiques des SAV
  getStats: async () => {
    const response = await api.get('/api/savs/stats');
    return response.data;
  },

  // Récupérer un SAV par ID
  getSavById: (savId) => {
    return api.get(`/api/savs/${savId}`);
  },

  // Créer un nouveau SAV
  createSav: (savData) => {
    return api.post('/api/savs', savData);
  },

  // Mettre à jour un SAV
  updateSav: (savId, savData) => {
    return api.put(`/api/savs/${savId}`, savData);
  },

  // Supprimer un SAV
  deleteSav: (savId) => {
    return api.delete(`/api/savs/${savId}`);
  },
};

export default savsService;
